var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { EventEmitter } from 'events';
import appManager from '@tencent/yyb-fe-appmanager';
import { AppJsApi } from '../common/config';
import { AppStatus } from '../../../common/constants';
import loadJs from '../common/loadjs';
import { createDeeplink } from '../common/scheme';
import { errorLogger } from '../../debug';
import { AppPackage } from '../common/appInfo';
/**
 * 应用宝下载实现
 * http://tapd.oa.com/Myapp_Android/markdown_wikis/view/#1010102551006364935
 */
var YYBDownloader = /** @class */ (function (_super) {
    __extends(YYBDownloader, _super);
    function YYBDownloader(opt) {
        var _this = _super.call(this) || this;
        _this.name = 'YYBDownloader';
        _this.opt = __assign({}, opt);
        return _this;
    }
    YYBDownloader.prototype.ready = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, loadJs([AppJsApi.TBS, AppJsApi.YYB])];
                    case 1:
                        _a.sent();
                        this.regAdStat();
                        return [2 /*return*/];
                }
            });
        });
    };
    // 注意QB官方文档有误，browser.download.startDownload 的 needautoinstall 参数类型是 boolean，不是 String。
    YYBDownloader.prototype.start = function () {
        var app = this.opt;
        var appList = [{
                packageName: app.packagename,
                hnAppId: app.appId,
                appName: app.filename,
                channelId: app.channelId,
                url: app.url,
                autoOpen: 1,
                autoStart: 1,
                noWifiDialogShow: false,
            }];
        appManager.reg(appList, {
            scene: "",
            recommendId: ""
        });
        this.status = AppStatus.DOWNLOADING;
    };
    /**
     * 补充内核统计上报
     *  type 上报的环节(0:下载开始;1:下载结束;2:安装完成)
     */
    YYBDownloader.prototype.regAdStat = function () {
        var _a, _b;
        var _c = this.opt, url = _c.url, reportstring = _c.reportstring, reportstring1 = _c.reportstring1, reportstring2 = _c.reportstring2;
        if ((_b = (_a = window === null || window === void 0 ? void 0 : window.tbs) === null || _a === void 0 ? void 0 : _a.ad) === null || _b === void 0 ? void 0 : _b.reportMsgByURL) {
            window.tbs.ad.reportMsgByURL({
                'appUrl': url,
                'type': '0',
                'reportUrl': reportstring,
            });
            window.tbs.ad.reportMsgByURL({
                'appUrl': url,
                'type': '1',
                'reportUrl': reportstring1,
            });
            window.tbs.ad.reportMsgByURL({
                'appUrl': url,
                'type': '2',
                'reportUrl': reportstring2,
            });
        }
        else {
            errorLogger('异常:', 'reportMsgByURL', '无此方法');
        }
    };
    YYBDownloader.prototype.pause = function () {
        this.start();
    };
    YYBDownloader.prototype.resume = function () {
        this.start();
    };
    YYBDownloader.prototype.install = function () {
        this.start();
    };
    YYBDownloader.prototype.open = function () {
        var _a, _b;
        var _c = this.opt, packagename = _c.packagename, active = _c.active, posId = _c.posId;
        if (packagename === AppPackage.YYB) {
            return location.href = active;
        }
        if ((_b = (_a = window === null || window === void 0 ? void 0 : window.tbs) === null || _a === void 0 ? void 0 : _a.package) === null || _b === void 0 ? void 0 : _b.runApp) {
            return window.tbs.package.runApp({ packagename: packagename, url: active, PosID: posId, });
        }
        else {
            errorLogger('异常:', 'runApp', '无此方法');
        }
        if (active) {
            return location.href = active;
        }
        location.href = createDeeplink(packagename);
    };
    YYBDownloader.prototype.isInstalled = function () {
        var packagename = this.opt.packagename;
        return new Promise(function (resolve, reject) {
            var _a, _b;
            if ((_b = (_a = window === null || window === void 0 ? void 0 : window.tbs) === null || _a === void 0 ? void 0 : _a.package) === null || _b === void 0 ? void 0 : _b.isApkInstalled) {
                var isInstalled = window.tbs.package.isApkInstalled({ packagename: packagename });
                resolve(Number(isInstalled) === 1);
            }
            else {
                resolve(false);
                errorLogger('异常:', 'isApkInstalled', '无此方法');
            }
        });
    };
    YYBDownloader.prototype.getStatus = function () {
        var _a, _b;
        var url = this.opt.url;
        if ((_b = (_a = window === null || window === void 0 ? void 0 : window.tbs) === null || _a === void 0 ? void 0 : _a.download) === null || _b === void 0 ? void 0 : _b.getDownloadStatus) {
            return window.tbs.download.getDownloadStatus({ url: url });
        }
        else {
            errorLogger('异常:', 'getDownloadStatus', '无此方法');
        }
    };
    YYBDownloader.prototype.getProgress = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            appManager.queryAppState(function (state, pro, context, info) {
                var appId = info.appId;
                var downloader = appManager.getDownloader(appId);
                // 开始下载
                if (state === window.JsBridge.Download.STATE_READY) {
                    _this.status = AppStatus.DOWNLOADING;
                }
                // 下载中
                if (state === window.JsBridge.Download.STATE_DOWNLOADING) {
                    var progress = pro || downloader.info.down_percent || 0;
                    _this.status = AppStatus.DOWNLOADING;
                    resolve(progress);
                }
                // 下载完成
                if (state === window.JsBridge.Download.STATE_DOWNLOADED) {
                    _this.status = AppStatus.DOWNLOADED;
                }
                // 安装开始
                if (state === window.JsBridge.Download.STATE_INSTALLING) {
                    _this.status = AppStatus.INSTALLING;
                }
                // 安装结束
                if (state === window.JsBridge.Download.STATE_INSTALLED) {
                    _this.status = AppStatus.INSTALLED;
                }
            });
        });
    };
    return YYBDownloader;
}(EventEmitter));
export default YYBDownloader;
